export const TARGET_TYPE = {
  // MDRTC: 419800,  2023
  // MDRTP: 1679200
  //MDRTC: 444400, 2024
  //MDRTP: 1777600
  MDRTC: 512800,
  MDRTP: 888100
};
